import React, { ChangeEvent } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import useUserHook from 'hooks/useUserHook';

import { FormValues } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.types';
import {
    ALL_USERS_ACCESS_DESCRIPTION,
    ALL_USERS_RADIO_BUTTON_LABEL,
    INDIVIDUAL_USERS_ACCESS_DESCRIPTION,
    INDIVIDUAL_USERS_RADIO_BUTTON_LABEL,
} from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/ReportAccessSettings.consts';
import classes from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/ReportAccessSettings.module.scss';
import {
    allUsersOptionSelected,
    specificUsersOptionSelected,
} from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/AccessOptionSelection/AccessOptionSelection.utils';
import { DescriptionBelowChildDecorator } from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/AccessOptionSelection/DescriptionDecorator/DescriptionBelowChildDecorator';
import { Radio } from 'components/DesignSystem/Radio';

interface Props {
    accessOption: FormValues['accessListOption'];
}

export const AccessOptionSelection = ({ accessOption }: Props) => {
    // form context
    const { control, setValue, getValues } = useFormContext<FormValues>();
    const { username } = useUserHook();
    return (
        <div className={classes.radioOptionsWrapper}>
            <div className={classes.radioOptions}>
                <DescriptionBelowChildDecorator
                    classNameWrapper={classes.radioOption}
                    description={ALL_USERS_ACCESS_DESCRIPTION}
                    isSelected={accessOption === 'whole'}
                >
                    <Controller
                        render={({ field }) => {
                            const { ref, ...fieldWithoutRef } = field;
                            return (
                                <Radio
                                    {...fieldWithoutRef}
                                    value={'whole'}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                        fieldWithoutRef.onChange(e);
                                        allUsersOptionSelected(setValue);
                                    }}
                                    checked={accessOption === 'whole'}
                                    label={ALL_USERS_RADIO_BUTTON_LABEL}
                                    labelColor={'var(--text-brand-primary)'}
                                />
                            );
                        }}
                        name={'accessListOption'}
                        control={control}
                    />
                </DescriptionBelowChildDecorator>

                <DescriptionBelowChildDecorator
                    classNameWrapper={classes.radioOption}
                    description={INDIVIDUAL_USERS_ACCESS_DESCRIPTION}
                    isSelected={accessOption === 'specific'}
                >
                    <Controller
                        render={({ field }) => {
                            const { ref, ...fieldWithoutRef } = field;
                            return (
                                <Radio
                                    {...fieldWithoutRef}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                        fieldWithoutRef.onChange(e);
                                        specificUsersOptionSelected(getValues, username, setValue);
                                    }}
                                    value={'specific'}
                                    checked={accessOption === 'specific'}
                                    label={INDIVIDUAL_USERS_RADIO_BUTTON_LABEL}
                                    labelColor={'var(--text-brand-primary)'}
                                />
                            );
                        }}
                        name={'accessListOption'}
                        control={control}
                    />
                </DescriptionBelowChildDecorator>
            </div>
        </div>
    );
};
